// Central data + asset references for Dhanusha Production

export const CONTACT = {
  email: "dhanusha.production@gmail.com",
  phone: "8287738890",
  phoneDisplay: "+91 82877 38890",
  instagram: "https://www.instagram.com/dhanusha_production",
  region: "Delhi NCR",
};

export const ASSETS = {
  logo: "https://customer-assets-jai6qajn.emergentagent.net/job_ddfc4267-4fe2-454f-a7f0-f95dbd4aa049/artifacts/tmkq3yhp_unnamed.jpg",
  heroVideo: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/2yd917c4_Animate_image_for_website_hero_202608031824.mp4",
  heroPoster: "/posters/hero.jpg",
  thumb1: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/ekiznxzx_98.png",
  thumb2: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/qwj32ney_58.png",
  thumb3: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/505varu7_2.png",
  teaser: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/g982fezv_AQMOuV83Rpo8XoI9AbFyBmKR8wXmlmPAWIo29cycOUwv57mVaamxdCwxHsfkdI4LyXncGbQqGnVjjKHmFquZqXqUjLt2c9fZ.mp4",
  bts: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/73v152yv_728035463_18103608562992785_8445229392986515040_n.webp",
  lens: "https://images.unsplash.com/photo-1580852300513-9b50125bf293?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxjYW1lcmElMjBsZW5zJTIwZGFyayUyMGNpbmVtYXRpY3xlbnwwfHx8fDE3ODU0MjE0MjB8MA&ixlib=rb-4.1.0&q=85",
  mic: "https://images.unsplash.com/photo-1679411156707-9e97efa60381?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxwb2RjYXN0JTIwbWljcm9waG9uZSUyMGRhcmslMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzg1NDIxNDIwfDA&ixlib=rb-4.1.0&q=85",
};

// Designed YouTube thumbnails (portfolio showcase — all 16:9)
export const THUMBNAILS = [
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/3koyzlji_91.png", tag: "Exclusive" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/zyg94gs3_141.png", tag: "Travel" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/5d1n1hg0_280.png", tag: "News" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/jlohf5jo_278.png", tag: "Society" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/zk4e6ebb_225.png", tag: "Spiritual" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/ekiznxzx_98.png", tag: "Business" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/qwj32ney_58.png", tag: "Education" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/qrq0jz5e_16.png", tag: "Long-Form" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/0doxtbsa_13.png", tag: "Podcast" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/kycyzlv3_10.png", tag: "Interview" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/gvpjgujm_8.png", tag: "Story" },
  { src: "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/pce60he6_7.webp", tag: "YouTube" },
];

// Uploaded reel / teaser videos
export const REELS = [
  "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/ou49ja78_AQMF1nmO0Edl5vzGAzjqSiV0icq3ce1w3csJzPIfMlcM-evIGnOx5HlBu90wXf8melCbZ7RL23pFOnRM6T6y2VjZFxivFXMS.mp4",
  "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/67trtnes_AQMiYrcEYcLL5xwvDYtDxk9-PYlQZm1jN7ACNrscLOHfFjNsGYdM7CewMzDbT7nQHmk2Pi6GXyZCxHFpVrChuMVw2oWxAt-D.mp4",
  "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/ns93i0cn_AQMtLYEDyvouoTGZugnb8z9hMFEM5tvYYdXaQBwgshvmcxpc0afJ3BLTx7w6hqXGp9QMEglgSlhrKzR_4C8F4g2fINVeBsbm.mp4",
  "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/e7uz7dsd_AQNXoO7j5cr3moD7ZFKnr--lqCTVCEbVR5gIeQSibIXb262-0_igMBAzDvuH4Ktymone_Ol9L_sdzA4vsUBybnadD80Y_1Wv.mp4",
  "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts/ivg94qrq_AQOlIBb2abv3vsk79QKw0xFxHocVQETQ-5SVqtUWFdIE1DaM1HptXL1V92MVu_Qh_lbMTROZV_9DR5Uo5Ae4PU-SjHbcGHap.mp4",
];

// Categorised showreel — reels/shorts (9:16), event shoots (9:16), BTS (16:9)
const ART = "https://customer-assets-rejwkqb3.emergentagent.net/job_visual-create-40/artifacts";
export const SHOWREEL = {
  reels: {
    label: "Reels & Shorts",
    slate: "Reel 03",
    scene: "Featured · Cuts",
    aspect: "9/16",
    items: [
      { src: REELS[0], poster: "/posters/r1.jpg" },
      { src: REELS[1], poster: "/posters/r2.jpg" },
      { src: REELS[2], poster: "/posters/r3.jpg" },
      { src: REELS[3], poster: "/posters/r4.jpg" },
      { src: REELS[4], poster: "/posters/r5.jpg" },
      { src: `${ART}/g982fezv_AQMOuV83Rpo8XoI9AbFyBmKR8wXmlmPAWIo29cycOUwv57mVaamxdCwxHsfkdI4LyXncGbQqGnVjjKHmFquZqXqUjLt2c9fZ.mp4`, poster: "/posters/teaser.jpg" },
    ],
  },
  events: {
    label: "Event & Outdoor Shoots",
    slate: "Reel 04",
    scene: "On Location",
    aspect: "9/16",
    items: [
      { src: "/videos/superyou.mp4", poster: "/posters/events/superyou.jpg", title: "Superyou · Brand Reel" },
      { src: "/videos/baby-feme-nest.mp4", poster: "/posters/events/baby-feme-nest.jpg", title: "Baby Feme Nest" },
      { src: "/videos/coworkzen.mp4", poster: "/posters/events/coworkzen.jpg", title: "Coworkzen" },
      { src: "/videos/event-draft-1.mp4", poster: "/posters/events/event-draft-1.jpg", title: "Event Highlight" },
      { src: `${ART}/dhqgfa0n_CM%20Event%20Highlight%20Short%2013%20April%20Part%201.mp4`, poster: "/posters/ev_cm.jpg", title: "CM Event Highlight" },
      { src: `${ART}/zfp98fub_Marathon%201st%20Short%2020%20April%202nd%20Draft.mp4`, poster: "/posters/ev_marathon.jpg", title: "Marathon Coverage" },
      { src: `${ART}/fy6w529u_CRICKET.mp4`, poster: "/posters/ev_cricket.jpg", title: "Cricket Highlights" },
    ],
  },
  bts: {
    label: "Behind The Scenes",
    slate: "Reel 05",
    scene: "On Set",
    aspect: "16/9",
    items: [
      { src: `${ART}/urfyplxs_20260123_140651.mp4`, poster: "/posters/bts1.jpg", title: "On Set — Take 1" },
      { src: `${ART}/gzqqzp0w_20260204_130205.mp4`, poster: "/posters/bts2.jpg", title: "On Set — Take 2" },
      { src: `${ART}/ks2erc88_20260607_201436.mp4`, poster: "/posters/bts3.jpg", title: "On Set — Take 3" },
      { src: `${ART}/ou9ekmpr_20260620_141958.mp4`, poster: "/posters/bts4.jpg", title: "On Set — Take 4" },
      { src: `${ART}/54bwrbyv_20260629_111023.mp4`, poster: "/posters/bts5.jpg", title: "On Set — Take 5" },
      { src: `${ART}/f2q8wnuf_20260707_125946.mp4`, poster: "/posters/bts6.jpg", title: "On Set — Take 6" },
    ],
  },
};

// Behind-the-scenes photo wall (auto-oriented locally)
export const BTS_PHOTOS = [
  "/bts/bts1.jpg",
  "/bts/bts2.jpg",
  "/bts/bts3.jpg",
  "/bts/bts4.jpg",
  "/bts/bts5.jpg",
  "/bts/bts6.jpg",
  "/bts/bts7.jpg",
  "/bts/bts8.jpg",
];

// Studio walk-through / introduction video (9:16 vertical)
export const STUDIO_INTRO = {
  src: `${ART}/2efvv372_VID_20260728_112300_858_bsl.mp4`,
  poster: "/posters/studio_intro.jpg",
};

export const HERO_CHIPS = [
  { label: "Shoots across", value: "Delhi NCR" },
  { label: "Setup", value: "Multi-Camera" },
  { label: "On-ground", value: "Full Crew + Lighting" },
  { label: "Delivery", value: "Edit + Reels + SEO" },
];

export const SERVICES = [
  { title: "Outdoor Shoots — All Types", icon: "Tent", desc: "On-location podcasts, interviews, brand & event shoots with full crew, lighting and sound." },
  { title: "Multi-Camera Podcast Setup", icon: "Video", desc: "Synced multi-angle rigs for dynamic, broadcast-grade conversations." },
  { title: "Professional Video Editing", icon: "Clapperboard", desc: "Story-first edits, color grade and sound design that hold attention." },
  { title: "YouTube & Reels Editing", icon: "Youtube", desc: "Platform-native cuts engineered for watch-time and retention." },
  { title: "Short-Form Content Creation", icon: "Zap", desc: "Scroll-stopping shorts crafted from your long-form gold." },
  { title: "Thumbnail Design", icon: "Image", desc: "Click-magnet thumbnails tested for maximum CTR." },
  { title: "Graphic Design", icon: "PenTool", desc: "Posters, carousels and brand collateral with a premium finish." },
  { title: "Motion Graphics", icon: "Sparkles", desc: "Kinetic titles, lower-thirds and animated brand moments." },
  { title: "Branding & Visual Identity", icon: "Fingerprint", desc: "Logos, palettes and systems that make you unmistakable." },
  { title: "Social Media Strategy", icon: "TrendingUp", desc: "Content calendars and hooks built to compound your reach." },
  { title: "Content Writing", icon: "FileText", desc: "Scripts, captions and copy that sound exactly like you." },
  { title: "SEO & YouTube SEO", icon: "Search", desc: "Titles, tags and metadata tuned to get discovered." },
  { title: "Corporate & Commercial Video", icon: "Building2", desc: "Brand films and ads that elevate how the world sees you." },
];

export const TEASERS = [
  { title: "Salary Won't Make You Rich", guest: "Suresh Mansharamani", tag: "Business" },
  { title: "UPSC Success Strategy", guest: "Nachiketa Sir", tag: "Education" },
  { title: "Neeb Karoli Baba", guest: "Devotional Special", tag: "Spiritual" },
];

export const STATS = [
  { value: "250+", label: "Episodes Produced" },
  { value: "40M+", label: "Views Generated" },
  { value: "80+", label: "Creators Served" },
  { value: "13", label: "Services Under One Roof" },
];

// "This is for you if you're a..." persona grid (SCENE cards)
const PERSONA_IMG = {
  podcast: "https://images.unsplash.com/photo-1589903308904-1010c2294adc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwyfHxwb2RjYXN0JTIwc3R1ZGlvJTIwbWljcm9waG9uZSUyMGRhcmslMjBzZXR1cHxlbnwwfHx8fDE3ODU2NjM1NDh8MA&ixlib=rb-4.1.0&q=85",
  edit: "https://images.pexels.com/photos/29505140/pexels-photo-29505140.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  crew: "https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwyfHxmaWxtJTIwcHJvZHVjdGlvbiUyMGNyZXclMjBiZWhpbmQlMjB0aGUlMjBzY2VuZXN8ZW58MHx8fHwxNzg1NjYzNTQ4fDA&ixlib=rb-4.1.0&q=85",
};

export const PERSONAS = [
  { title: "Podcasters & Hosts", icon: "Mic", img: PERSONA_IMG.podcast, desc: "Turn up and talk — we handle cameras, sound, lighting and the edit." },
  { title: "YouTubers & Creators", icon: "Youtube", img: PERSONA_IMG.edit, desc: "Long-form, reels and thumbnails engineered to grow your channel." },
  { title: "Coaches & Educators", icon: "GraduationCap", img: PERSONA_IMG.crew, desc: "Authority-building content that turns viewers into students." },
  { title: "Founders & Brands", icon: "Rocket", img: PERSONA_IMG.podcast, desc: "Founder-led shows and brand films that build trust at scale." },
  { title: "Spiritual & Devotional", icon: "Sparkles", img: PERSONA_IMG.edit, desc: "Emotive storytelling and reels that travel far and resonate deep." },
  { title: "Events & Corporates", icon: "Building2", img: PERSONA_IMG.crew, desc: "Commercials, aftermovies and corporate films, shot end-to-end." },
];

// Before / After comparison (DIY vs Dhanusha)
export const COMPARISON = [
  { before: "Juggling camera, audio, edit & clients alone", after: "A full crew arrives, sets up and rolls — you just talk" },
  { before: "One raw file that never becomes content", after: "An edited episode plus 5–10 reels from every shoot" },
  { before: "Guessing thumbnails and titles", after: "CTR-tested thumbnails and YouTube-SEO'd titles" },
  { before: "Chasing five freelancers for one video", after: "Thirteen services under one roof, one point of contact" },
  { before: "Inconsistent uploads, stalling growth", after: "A repeatable system that keeps your channel shipping" },
];

// "What you get" deliverables
export const TAKEAWAYS = [
  { title: "A Ready-To-Shoot Studio, On Location", desc: "Multi-cam rig, lighting, mics and a calm crew arrive and set up anywhere in Delhi NCR." },
  { title: "Full Episode, Edited To Retain", desc: "Color, sound and pacing tuned so viewers actually watch to the end." },
  { title: "Reels & Shorts From Every Episode", desc: "5–10 scroll-stopping cuts per shoot, formatted for every platform." },
  { title: "Click-Magnet Thumbnails", desc: "Tested designs built to push your click-through rate up." },
  { title: "SEO That Gets You Found", desc: "Titles, tags and descriptions optimised for YouTube search." },
  { title: "One Partner For Everything", desc: "From branding to motion graphics — thirteen services under one roof." },
];

// Client YouTube channels (social proof)
export const CHANNELS = [
  { name: "Podcast With Anchal", handle: "@podcastwithanchal", url: "https://youtube.com/@podcastwithanchal" },
  { name: "The Asad Talk", handle: "@theasadtalk", url: "https://youtube.com/@theasadtalk" },
  { name: "Abhishek Kar", handle: "@abhishekkar", url: "https://youtube.com/@abhishekkar" },
  { name: "Naagru Vikaas", handle: "@naagruvikaas6474", url: "https://youtube.com/@naagruvikaas6474" },
  { name: "Podcast By Dhananjay", handle: "@podcastbydhananjay", url: "https://youtube.com/@podcastbydhananjay" },
  { name: "FYI by Aditya Goel", handle: "@fyibyadityagoel", url: "https://youtube.com/@fyibyadityagoel" },
  { name: "Jitendra Vaswani", handle: "@jitendravaswani", url: "https://youtube.com/@jitendravaswani" },
  { name: "The Yogesh Pranav Show", handle: "@theyogeshpranavshow", url: "https://youtube.com/@theyogeshpranavshow" },
  { name: "TED Shark Labs", handle: "@tedsharklabs", url: "https://youtube.com/@tedsharklabs" },
];

// Featured YouTube video (direct link provided)
export const FEATURED_VIDEO_ID = "ZAqmEKc_7CA";

// Featured episodes across client channels — playable embeds
export const FEATURED_EPISODES = [
  { id: "ZAqmEKc_7CA", channel: "Featured Episode" },
  { id: "M1AenqIKtcw", channel: "Podcast with Anchal" },
  { id: "81o1W-Tavi4", channel: "Abhishek Kar" },
  { id: "u-tnWNEyazw", channel: "TED Shark Labs" },
  { id: "H6Ght2wlsnA", channel: "Jitendra Vaswani" },
];

// Placeholder testimonials (editable, hidden by default via admin toggle)
export const TESTIMONIALS = [
  { quote: "Dhanusha turned our raw conversations into a channel that actually grows. The crew is calm, fast and genuinely creative.", name: "Client Name", role: "Podcast Host" },
  { quote: "Booked a shoot, showed up, spoke — and got a full episode plus ten reels. Effortless and premium end to end.", name: "Client Name", role: "Founder" },
  { quote: "The thumbnails and edits pushed our watch-time to a level we couldn't hit on our own. Highly recommend.", name: "Client Name", role: "Educator" },
];

export const FAQS = [
  { q: "Where do you shoot?", a: "We shoot anywhere across Delhi NCR — your office, home, a studio or an outdoor location. We bring the entire setup to you." },
  { q: "What's included in a podcast shoot?", a: "Multi-camera setup, professional lighting, microphones, a full crew on the day, and post-production including the edited episode, reels and thumbnails." },
  { q: "How soon can I book?", a: "Reach out with your preferred date and we'll confirm availability, usually within 24 hours." },
  { q: "Do you only do podcasts?", a: "No — we cover 13 services including reels, thumbnails, branding, motion graphics, SEO and corporate/commercial video production." },
  { q: "Will I get short-form content too?", a: "Yes. Every shoot can include 5–10 reels/shorts cut from the episode, formatted for YouTube, Instagram and other platforms." },
];

export const MANIFESTO = [
  { n: "01", title: "We Roll, You Talk", body: "You bring the story. We bring the cameras, lights, mics and the calm crew that makes it effortless." },
  { n: "02", title: "Edited To Be Watched", body: "Every cut is engineered for retention — pacing, sound and motion that keep thumbs from scrolling." },
  { n: "03", title: "One Partner, Every Format", body: "Long-form, reels, thumbnails, branding, SEO. Thirteen services under one cinematic roof." },
];
